/**
 * @file: cube拖拽交互
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree';
import * as StageStatus from '../../stageStatus';
import GoodsDrag from './goods';
import CabinetGoods from './cabinetGoods';
import CabinetTextarea from './cabinetTextarea';
import TextareaDrag from './textarea';
import BafflePlateDrag from './bafflePlate';
import ShelfDrag from './shelf';
import FreezerDrag from './freezer';
import LayerDrag from './layer';

function init(): void {
    // 卧柜
    if (StageStatus.isTopFace()) {
        FreezerDrag.init();
        CabinetGoods.init();
        CabinetTextarea.init();
        return;
    }

    // 商品拖拽
    GoodsDrag.init();

    // 文本框拖拽
    TextareaDrag.init();

    // 隔板拖拽
    BafflePlateDrag.init();

    // 立式货架
    ShelfDrag.init();

    // 层板
    LayerDrag.init();
}

function add(cubeId: CubeId): void {
    let allChildren: Array<CubeId> = CubeTree.findAllChildrenContainSelf(cubeId);

    // 卧柜
    if (StageStatus.isTopFace()) {
        allChildren.forEach((cube: CubeId): void => {
            if (CubeTree.isFreezer(cube)) {
                FreezerDrag.add(cube);
                return;
            }

            if (CubeTree.isGoods(cube)) {
                CabinetGoods.add(cube);
                return;
            }

            if (CubeTree.isTextarea(cube)) {
                CabinetTextarea.add(cube);
                return;
            }
        });
        return;
    }

    allChildren.forEach((cube: CubeId): void => {
        if (CubeTree.isGoods(cube)) {
            GoodsDrag.add(cube);
            return;
        }

        if (CubeTree.isTextarea(cube)) {
            TextareaDrag.add(cube);
            return;
        }

        if (CubeTree.isBafflePlate(cube)) {
            BafflePlateDrag.add(cube);
            return;
        }

        if (CubeTree.isShelf(cube)) {
            ShelfDrag.add(cube);
            return;
        }

        if (CubeTree.isShelfPartition(cube)) {
            LayerDrag.add(cube);
            return;
        }
    });
}

export default {
    init,
    add
}
